import styled from 'styled-components';
import { green400, primary200, primary800 } from '../themes/colors';

interface HeroSectionVideoRootProps {
  position?: 'left' | 'right';
}

export const HeroSectionVideoRoot = styled.div<HeroSectionVideoRootProps>`
  font-family: ${props => props.theme.font};
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  direction: ${({ position = 'left' }) => position === 'right' ? 'rtl' : 'ltr'};

  > * {
    direction: ltr;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Heading = styled.h3`
  display: flex;
  font-family: ${props => props.theme.font};
`;

export const HeadingText = styled.div`
  color: ${primary200};
`;

export const FeatureText = styled.span`
  color: ${green400};
`;

export const MainText = styled.span<{
  $isAdmin?: boolean,
}>`
  color: ${primary800};
  font-family: ${props => props.theme.font};
  margin-bottom: ${({ $isAdmin }) => ($isAdmin ? '0' : '12px')};
`;

export const Subtext = styled.p`
  color: ${primary200};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 24px 0 12px;
  gap: 8px;
`;

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0;
  font-family: ${props => props.theme.font};

`;

export const HubspotFormWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  #hubspot-embedded-form {
    background: white;
    padding: 24px;
    border-radius: 8px;
    width: 100%;
    max-width: 600px;
    margin: 20px;
  }
`;

export const VideoSection = styled.div<{
  $showBorder?: boolean,
}>`
  border: ${({ $showBorder }) => ($showBorder ? `1px solid ${primary200}` : '1px solid transparent')};
  display: flex;
  flex-direction: column;
  height: auto;
  width: 100%;
  min-height: 300px;
  border-radius: 2px;

  iframe, .vimeo-player {
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
    border: none;
  }
`;
